module.exports = __webpack_public_path__ + "assets/97bdac1c2bacd8ad95621a6ec39c35a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/next-trip.jpg
// module id = 1014
// module chunks = 0